import Styles from '../../1.manual/4.sending/styles.module.css';
import Styless from '../../styles.module.css';
import Items from '../../1.manual/4.sending/1.item/index';
import SendModal from '../../1.manual/4.sending/3.send_modal/index';
import { useState } from 'react';
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAppSelector } from 'src/salon/app/hook';
import { schoolList } from 'src/type';
import Confirm from '../../1.manual/4.sending/confirm/index';
import { isSupportedJobPostingYear } from '../jobPostingRef';

// 送付先の選択画面。
// 初期設定(オンボーディング)の1.manual/4.sending(送付先の学校を選択しましょう)と
// 同じ選択UI・コンポーネント群を再利用するが、オンボーディング専用の
// 幅広ラッパー(Styles.plan)と見出し(「1.送付先の学校を選択しましょう！」)は表示せず、
// 求人票の編集(2.jobPostings/edit)と同じ幅で表示する。
// 送付先は URL の年度(/service/jobPostings/:year/sending)ごとに `${year}_sending` へ保存する。
const JobPostingSending: React.FC = () => {

  const { year } = useParams<{ year: string }>();

  const [ checkList, setCheckList ] = useState<string[]>([]);
  const [ sendModal, setSendModal ] = useState<boolean>(false);
  const [ searchText, setSearchText ] = useState<string>('');

  const company = useAppSelector((state) => state.company.company);

  const filteredSchoolList = searchText === ''
    ? schoolList
    : schoolList.filter((data) => data[1].includes(searchText));

  // 許可されていない年度(不正なURL)のまま送ると、存在しない年度の送付先が保存されてしまうため、一覧へ戻す。
  if (!isSupportedJobPostingYear(year)) {
    return <Navigate to="/service/jobPostings" replace />;
  }

  return (
    <>
    <div className={Styless.works_service}>
    <div>

      {company.contract ?
      <>
        <Confirm completePath="/service/jobPostings" />
      </>
      :
      <>
        {checkList && (
          <button className={Styles.send_jobPostings} style={checkList.length !== 10 ? {backgroundColor: '#EBEBEB'} : {} } onClick={() => checkList.length !== 10 ? "" : setSendModal(true)}>求人票を送信する</button>
        )}

        <p className={Styles.send_upper}>選択学校数：{checkList.length}校 / 10校</p>

        <input
          className={Styles.search}
          type="text"
          placeholder="学校名で検索"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />

        <div className={Styles.manage}>
          <div className={Styles.manage_header}>
            <div className={Styles.manage_table}>
              <div style={{width: '15px'}}></div>
              <p className={Styles.items_table_box_1}>学校名</p>
              <p className={Styles.items_table_box_2}>地方</p>
              <p className={Styles.items_table_box_2}>都道府県</p>
              <p className={Styles.items_table_box_3}>住所</p>
              <div style={{ flexGrow: 1 }}></div>
            </div>
          </div>

          {filteredSchoolList.map((data) =>
            <Items key={data[0]} school={data} checkList={checkList} setCheckList={setCheckList} />
          )}
        </div>
      </> }

    </div>
    </div>

    {sendModal && company.id !== "" ?
      <SendModal companyId={company.id} year={year} schools={checkList} completePath="/service/jobPostings" setSendModal={setSendModal} setCheckList={setCheckList} />
    : <></> }
    </>
  );
}

export default JobPostingSending;
